import { cn } from '@/utils/cn';

const FALLBACK = '#e4e5e7';

export function AppearancePreview({
  hex,
  patternImageUrl,
  finishImageUrl,
  label,
  className,
}: {
  hex?: string | null;
  patternImageUrl?: string | null;
  finishImageUrl?: string | null;
  label: string;
  className?: string;
}) {
  const empty = !hex && !patternImageUrl && !finishImageUrl;
  return (
    <div
      role="img"
      aria-label={label}
      className={cn(
        'relative isolate overflow-hidden rounded border border-black/10 bg-neutral-100',
        className
      )}
      style={{ backgroundColor: hex || FALLBACK }}
    >
      {patternImageUrl && (
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url("${patternImageUrl}")`,
            opacity: hex ? 0.6 : 1,
            mixBlendMode: hex ? 'multiply' : undefined,
          }}
        />
      )}
      {finishImageUrl && (
        <div
          className="absolute inset-0 bg-cover bg-center opacity-30 mix-blend-overlay"
          style={{ backgroundImage: `url("${finishImageUrl}")` }}
        />
      )}
      {empty && (
        <div
          className="absolute inset-0 flex items-center justify-center text-neutral-400 text-xl"
          aria-hidden="true"
        >
          ∅
        </div>
      )}
    </div>
  );
}
